// Ported from files/snapdraw-design-kit/code/src/lib/i18n/strings/feedback.ts
// (Rule 19). `feedback.submitError` is new here — the kit's submit handler
// was a no-op that could never fail; a real one can.
export const en = {
  "feedback.open": "Feedback",
  "feedback.title": "Send feedback",
  "feedback.body":
    "Tell the Shaman Technologies team what's working, what isn't, or ask us a question. We read every note.",
  "feedback.kind": "What kind of feedback?",
  "feedback.kind.praise": "Something I like",
  "feedback.kind.issue": "Something's broken",
  "feedback.kind.idea": "Idea / request",
  "feedback.kind.question": "Question",
  "feedback.message": "Your feedback",
  "feedback.messagePlaceholder.praise": "The part of SnapDraw that's saving me time is…",
  "feedback.messagePlaceholder.issue": "What happened, and what did you expect instead?",
  "feedback.messagePlaceholder.idea": "It would help my crew if SnapDraw could…",
  "feedback.messagePlaceholder.question": "What would you like to know?",
  "feedback.required": "Add a short note so we know what to look at.",
  "feedback.reply": "Reply to",
  "feedback.replyHelp": "We'll only use this to answer you.",
  "feedback.context": "Sent with",
  "feedback.contextHelp": "Screen: {screen}",
  "feedback.cancel": "Cancel",
  "feedback.submit": "Send feedback",
  "feedback.sent": "Feedback sent",
  "feedback.sentBody": "Thanks — the Shaman Technologies team has your note.",
  "feedback.done": "Close",
  "feedback.toast": "Thanks for the feedback",
  "feedback.submitError": "Couldn't send — check your connection and try again.",
} as const;

export const es: Record<keyof typeof en, string> = {
  "feedback.open": "Comentarios",
  "feedback.title": "Enviar comentarios",
  "feedback.body":
    "Dile al equipo de Shaman Technologies qué funciona, qué no, o haznos una pregunta. Leemos cada nota.",
  "feedback.kind": "¿Qué tipo de comentario?",
  "feedback.kind.praise": "Algo que me gusta",
  "feedback.kind.issue": "Algo no funciona",
  "feedback.kind.idea": "Idea / solicitud",
  "feedback.kind.question": "Pregunta",
  "feedback.message": "Tu comentario",
  "feedback.messagePlaceholder.praise": "Lo que más tiempo me ahorra de SnapDraw es…",
  "feedback.messagePlaceholder.issue": "¿Qué pasó y qué esperabas en su lugar?",
  "feedback.messagePlaceholder.idea": "Ayudaría a mi cuadrilla si SnapDraw pudiera…",
  "feedback.messagePlaceholder.question": "¿Qué te gustaría saber?",
  "feedback.required": "Agrega una nota breve para saber qué revisar.",
  "feedback.reply": "Responder a",
  "feedback.replyHelp": "Solo lo usaremos para responderte.",
  "feedback.context": "Enviado con",
  "feedback.contextHelp": "Pantalla: {screen}",
  "feedback.cancel": "Cancelar",
  "feedback.submit": "Enviar comentarios",
  "feedback.sent": "Comentario enviado",
  "feedback.sentBody": "Gracias — el equipo de Shaman Technologies tiene tu nota.",
  "feedback.done": "Cerrar",
  "feedback.toast": "Gracias por tus comentarios",
  "feedback.submitError": "No se pudo enviar — revisa tu conexión e inténtalo de nuevo.",
};
